"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var TCell_1 = require("./TCell");
var TCheckboxCell = /** @class */ (function (_super) {
    __extends(TCheckboxCell, _super);
    function TCheckboxCell(props) {
        var _this = _super.call(this, props) || this;
        // Prevent text highlighting
        _this.onMouseDown = function (e) {
            return e.shiftKey && e.preventDefault();
        };
        _this.onMouseDown = _this.onMouseDown.bind(_this);
        _this.onClick = _this.onClick.bind(_this);
        return _this;
    }
    TCheckboxCell.prototype.onClick = function (e) {
        var onInputClick = this.props.onInputClick;
        e.shiftKey && e.currentTarget.focus(); // Focus current target on click for styling purposes
        onInputClick && onInputClick(e);
    };
    TCheckboxCell.prototype.render = function () {
        var _a = this.props, ariaLabel = _a.ariaLabel, label = _a.label, checked = _a.checked, disabled = _a.disabled, disabledText = _a.disabledText, onInputChange = _a.onInputChange, rest = __rest(_a, ["ariaLabel", "label", "checked", "disabled", "disabledText", "onInputChange"]);
        var cellProps = __assign({}, rest, { className: "oui-table-shrink" });
        delete cellProps.onInputClick; // Don't want to pass this to TCell
        var inputAriaLabel = disabledText ? disabledText : (label || ariaLabel);
        return (React.createElement(TCell_1.default, __assign({}, cellProps),
            React.createElement("input", { "aria-label": inputAriaLabel, checked: checked, disabled: disabled, onChange: onInputChange, onClick: this.onClick, type: "checkbox", className: "oui-checkbox oui-react-checkbox oui-margin-small-left oui-margin-small-right", value: "", onMouseDown: this.onMouseDown, title: disabledText ? disabledText : undefined })));
    };
    return TCheckboxCell;
}(React.Component));
exports.default = TCheckboxCell;
//# sourceMappingURL=TCheckboxCell.js.map